export class UnknownCreationSetError extends Error {
  constructor() {
    super(`Unknown creationSet`);
  }
}

export class UnknownCreativeFormatError extends Error {
  constructor(id?: string) {
    super(`Unknown creativeFormat (id or tmpid: ${id})`);
  }
}

export class ProjectStateNotPreparedError extends Error {
  constructor() {
    super("The project's `project` state has not been prepared.");
  }
}
